import { type FC } from 'react';

/**
 * Check glyph for the "fully explored" inside-scene badge — taken verbatim
 * from the design (Figma node 2585:34546, Phosphor "Check"). Drawn in the
 * 20×20 badge coordinate space. `stroke="currentColor"` so the badge's
 * `color` (gold `#ad7f00`) drives it; the `#fffae0` pill is the badge bg.
 */
export const CheckIcon: FC = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M5.875 10.75L8.5 13.375L14.5 7.375"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
